import {Component, Input, OnInit} from '@angular/core';
import {WetterPdfProducts} from '../../../../../../../model/vorhersagen/rbb-document';

@Component({
  selector: 'app-wetter-karte-pdf-bericht',
  templateUrl: './wetter-karte-pdf-bericht.component.html',
  styleUrls: ['./wetter-karte-pdf-bericht.component.css', '../../wetterbericht.component.css']
})
export class WetterKartePdfBerichtComponent {

  @Input()
  public wetterPdf: WetterPdfProducts;

  openLink(link: string | undefined) {
    if (link) {
      window.open(link, '_blank');
    }
  }
}
